export default __webpack_public_path__ + "static/media/icon-scene-planet.e0074cdb.svg";